import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class WorkerEntity implements Entity {
  public static fromXML(xml, matchIDs) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.Worker.WorkerId];
    return {
      entity: new WorkerEntity(
        matchIDs[isoId] ? matchIDs[isoId].id : null,
        attrs[ATTRS.Worker.WorkerFirstName],
        attrs[ATTRS.Worker.WorkerLastName]
      ),
      isoId,
    };
  }
  public type = TAGS.Worker;
  public id;

  constructor(
    id: number,
    private firstName: string,
    private lastName: string
  ) {
    this.id = id;
  }

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.Worker.WorkerId]: xmlId,
        [ATTRS.Worker.WorkerLastName]: this.lastName,
        [ATTRS.Worker.WorkerFirstName]: this.firstName,
      },
    };
  }
}
